export default {
  nav: {
    home: 'Home',
    about: 'About Us',
    philosophy: 'Philosophy',
    business: 'Business',
    news: 'News',
    contacts: 'Contact',
    getQuote: 'Get Quote',
    getAQuote: 'Get a Quote',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
};
